// extracted by mini-css-extract-plugin
export var center = "_5a-2";
export var clickableRow = "_5a-5";
export var expandedRow = "_5a-7";
export var hoverable = "_5a-4";
export var left = "_5a-1";
export var right = "_5a-3";
export var row = "_5a-0";
export var selectedRow = "_5a-6";
export var summaryRow = "_5a-8";